var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _circle3, _circle4, _circle5, _circle6, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticMarketingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9717,
    cy: 17.4648,
    r: 6.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9717,
    cy: 17.4648,
    r: 8.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.46484V6.46484C26 5.36027 25.1046 4.46484 24 4.46484H6C4.89543 4.46484 4 5.36027 4 6.46484V28.4648C4 29.5694 4.89543 30.4648 6 30.4648H24C25.1046 30.4648 26 29.5694 26 28.4648L26 25.4648",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27.4648V31C29 32.6569 27.6569 34 26 34H4C2.34315 34 1 32.6569 1 31V4C1 2.34314 2.34315 1 4 1H26C27.6569 1 29 2.34315 29 4V7.46484",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47168 20.4648H20.4717",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97168 23.4648H13.9717",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9717 23.4648H21.9717",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97168 26.4648H20.4717",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.4717,
    y: 30.4648,
    width: 3,
    height: 9,
    rx: 1.5,
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9717 26.4648V29.9648",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9717 11.4648L8.97168 13.4648",
    stroke: "white",
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9717 12.4648L13.9717 11.4648",
    stroke: "white",
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9717 12.4648L20.9717 10.4648",
    stroke: "white",
    strokeLinecap: "square"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.97168,
    cy: 14.4648,
    r: 1.5,
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9717,
    cy: 10.4648,
    r: 1.5,
    stroke: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9717,
    cy: 13.4648,
    r: 1.5,
    stroke: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9717,
    cy: 9.46484,
    r: 1.5,
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4717 17.4648L29.7646 19.7577C30.1551 20.1483 30.7883 20.1483 31.1788 19.7577L35.9717 14.9648",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticMarketingIcon);
export default __webpack_public_path__ + "static/media/analyticMarketingIcon.e17bf2b3a6767322d60070aa86fb37ca.svg";
export { ForwardRef as ReactComponent };